import { useTranslation } from '~src/i18n/use-translation';

export const Validate = () => {
  const { t } = useTranslation();

  const validationRules = {
    city: {
      required: t('common.fieldRequired', {
        field: t('common.city'),
      }),
    },
    country: {
      required: t('common.fieldRequired', {
        field: t('common.country'),
      }),
    },
    email: {
      pattern: {
        message: t('addressBook.details.validateEmailFormat'),
        value: /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/,
      },
    },
    name: {
      required: t('common.fieldRequired', {
        field: t('common.name'),
      }),
    },
    phone: {
      maxLength: { message: t('addressBook.details.validatePhoneMax', { max: 15 }), value: 15 },
      minLength: {
        message: t('addressBook.details.validatePhoneMin', { min: 7 }),
        value: 7,
      },
      pattern: {
        message: t('addressBook.details.validatePhoneFormat'),
        value: /^\+[0-9]*$/,
      },
    },
    postal_code: {
      maxLength: {
        message: t('addressBook.details.validatePostalCodeMax', { max: 10 }),
        value: 10,
      },
      minLength: {
        message: t('addressBook.details.validatePostalCodeMin', { min: 3 }),
        value: 3,
      },
      pattern: {
        message: t('addressBook.details.validatePostalCodeFormat'),
        value: /^[a-zA-Z0-9- ]*$/,
      },
      required: t('common.fieldRequired', {
        field: t('common.postalCode'),
      }),
    },
  };

  return validationRules;
};
